import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetLateFeeConfigsQuery } from "../../../hooks/useGetLateFeeConfigsQuery";
import { setLateFeeConfigData } from "../../../redux/slices/finance/lateFeeConfig";
import { routes } from "../../../routes";
import { updatePaymentType } from "../../../services/finance/paymentType";
import { PaymentType } from "../../../types/Finance";
import { Key_paymenttypies } from "../../../utils/constants";
import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";
import { setPaymentTypeData } from "../../../redux/slices/finance/paymentType";
import { internalCodes } from "../../../utils/codes";

const columnNamesMap: { [key: string]: string } = {
  description: 'Descrição',
  amount: 'Valor de pagamento',
  internalCode: 'Tipo de emolumento',
};

export const PaymentTypes = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetPaymentTypesQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<PaymentType | null>(null);
  const mutationUpdate = useMutation(updatePaymentType, {
    onSuccess: () => {
        queryClient.invalidateQueries(Key_paymenttypies);
        toast.success('Tipo de emolumento apagado');
    },
    onError: () => {
        toast.error("Erro ao apagar Tipo de emolumento.")
    }
});
const handlePageChange = (page: number) => {
  setCurrentPage(page);
};
const handleClickCreate = (event: any): void => {
  navigate(routes.createPaymentType)
}
const handleEdit = (c: PaymentType) => {
  dispatch(setPaymentTypeData(c));
  navigate(routes.updatePaymentType)
};
const handleDelete = (c: PaymentType) => {
  c.status = false;
  mutationUpdate.mutateAsync(c)
};
const openDeleteDialog = (s: PaymentType) => {
  setDeleteItem(s);
};  
const confirmDelete = async () => {
  if (deleteItem) {
      await handleDelete(deleteItem!)
  }
};
const options = data?.items.map((c: PaymentType) => [
  {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
  },
  {
      label: 'Excluir',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
  }
]) || [];

const mappedItems = data?.items?.map(item => {
  const code = internalCodes.find(code => code.id === item.internalCode);
  return {
    ...item,
    internalCode: code ? code.description : item.internalCode, // substitui pela descrição
  };
});


return (
  <>
      <Lists
          status={status}
          TableComponent={() =>
              <TableComponent
                  columns={Object.keys(columnNamesMap)}
                  // items={data?.items}
                  items={mappedItems}
                  options={options}
                  columnNamesMap={columnNamesMap}
                  totalPages={data?.totalPages || 1}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
              />
          }
          handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
          open={!!deleteItem}
          onOpenChange={(open) => !open && setDeleteItem(null)}
          title="Esta operação é irreversível"
          item={deleteItem}
          onConfirm={confirmDelete}
          onCancel={() => setDeleteItem(null)}
      />
  </>
);
}
